import { render } from "./roll_call.vue?vue&type=template&id=094efb7c&scoped=true"
import script from "./roll_call.vue?vue&type=script&lang=js"
export * from "./roll_call.vue?vue&type=script&lang=js"

import "./roll_call.vue?vue&type=style&index=0&id=094efb7c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094efb7c"]])

export default __exports__